import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import { TypesInventoryEnum } from '../../InventoryTypes'
import * as S from './FormCreateInventory.styles'
import { actions } from '../../InventoryState'
import { AddSkus } from '../AddSkus/AddSkus'
import { selectBadges, selectSkusList } from '../../InventorySelector'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { Checkbox } from '@mui/material'
import { CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox } from '@mui/icons-material'

const filterTypeList = [TypesInventoryEnum.SIMPLE, TypesInventoryEnum.VALIDATE]

interface Props {
  setClickCreate: (value: boolean) => void
}

export const FormCreateInventory = ({ setClickCreate }: Props) => {
  const [skus, setSkus] = useState<any | string>('')
  const [useLostLocations, setUseLostLocations] = useState<boolean>(false)
  const skusList = useSelector(selectSkusList)
  const badges = useSelector(selectBadges)

  const { fc, validateFc } = useFulfillmentCenter()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  const userBadges = badges?.map(({ userBadge }) => userBadge)

  const productsCode = skusList
    .map(({ codProduct }) => codProduct)
    .filter((value, index, self) => self.indexOf(value) === index)

  const {
    register, getValues, reset, setError, setValue, formState: { errors },
  } = useForm()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.getBadges())
  }, [dispatch])

  const filterTypeListOptions = useMemo(() => filterTypeList.map((type, index) => ({
    description: type,
    id: index,
  })), [])

  const inventoryTypeMap = {
    0: 'Simples',
    1: 'Validade',
  }

  const onSubmit = () => {
    const type = getValues('typeInventoryList')
    const name = getValues('inventoryName')

    if (!name && !inventoryTypeMap[type] && !productsCode.length) {
      setError('inventoryName', { message: 'Campo obrigatório' })
      setError('typeInventoryList', { message: 'Campo obrigatório' })
      setError('skuToInventory', { message: 'Campo obrigatório' })
      return
    } if (name && !inventoryTypeMap[type] && !productsCode.length) {
      setError('typeInventoryList', { message: 'Campo obrigatório' })
      setError('skuToInventory', { message: 'Campo obrigatório' })
      return
    } if (!name && inventoryTypeMap[type] && !productsCode.length) {
      setError('inventoryName', { message: 'Campo obrigatório' })
      setError('skuToInventory', { message: 'Campo obrigatório' })
      return
    } if (!name && !inventoryTypeMap[type] && productsCode.length) {
      setError('inventoryName', { message: 'Campo obrigatório' })
      setError('typeInventoryList', { message: 'Campo obrigatório' })
      return
    } if (!name && inventoryTypeMap[type] && productsCode.length) {
      setError('inventoryName', { message: 'Campo obrigatório' })
      return
    } if (name && !inventoryTypeMap[type] && productsCode.length) {
      setError('typeInventoryList', { message: 'Campo obrigatório' })
      return
    } if (name && inventoryTypeMap[type] && !productsCode.length) {
      setError('skuToInventory', { message: 'Campo obrigatório' })
      return
    }

    dispatch(actions.createInventory({
      name,
      type: inventoryTypeMap[type],
      skus: productsCode,
      badges: userBadges,
      fulfillmentCenterId: fc.id,
      lost_locations: useLostLocations,
    }))
    setSkus('')
    setValue('inventoryName', '')
    setValue('typeInventoryList', '')
    reset()
    dispatch(actions.clearState())
  }

  return (
    <S.FilterContainer>
      <S.InputRowWrapper>
        <S.CustomTextField
          id='inventoryName'
          name='inventoryName'
          type='text'
          autoComplete='off'
          inputProps={{
            ...register('inventoryName', { required: 'Campo obrigatório' }),
            'data-testid': 'inventory-name-test',
            maxLength: 150,
          }}
          error={!!errors.inventoryName}
          label='inventory.name'
          helperText={errors.inventoryName?.message}
        />
        <S.CustomSelect
          defaultValue=''
          autoComplete='off'
          inputProps={{ ...register('typeInventoryList', { required: 'Campo obrigatório' }), 'data-testid': 'type-inventory-select' }}
          id='typeInventoryList'
          name='typeInventoryList'
          error={!!errors.typeInventoryList}
          label='Selecione o tipo da lista'
          helperText={errors.typeInventoryList?.message}
          variant='outlined'
          options={filterTypeListOptions}
          optionNone={false}
          type='text'
        />
        <S.CheckboxWrapper>
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize='small' />}
            checkedIcon={<CheckBox fontSize='small' />}
            indeterminateIcon={<IndeterminateCheckBox fontSize='small'/>}
            checked={useLostLocations}
            onChange={(event) => setUseLostLocations(event.target.checked)}
          />
          <span>Inventariar endereços perdidos</span>
        </S.CheckboxWrapper>
      </S.InputRowWrapper>
      <S.CustomContainerTextArea>
        <AddSkus skus={skus} setSkus={setSkus} errors={errors} register={register} />
      </S.CustomContainerTextArea>
      <S.ContainerButton>
        <S.CustomButton
          title='Criar'
          type='submit'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          disabled={skusList.some((item) => item.valid === false)}
          data-testid='create-inventory-button-form'
          onClick={() => onSubmit()}
        />
        <S.CustomButton
          title='Voltar'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          onClick={() => setClickCreate(false)}
          data-testid='button-back-create-inventory'
        />
      </S.ContainerButton>
    </S.FilterContainer>
  )
}
